// 网页当前状态判断
var PageVisible = function (onchange) {
    this._visible = false;

    (function (self) {
        var hidden, state, visibilityChange;
        if (typeof document.hidden !== "undefined") {
            hidden = "hidden";
            visibilityChange = "visibilitychange";
            state = "visibilityState";
        } else if (typeof document.mozHidden !== "undefined") {
            hidden = "mozHidden";
            visibilityChange = "mozvisibilitychange";
            state = "mozVisibilityState";
        } else if (typeof document.msHidden !== "undefined") {
            hidden = "msHidden";
            visibilityChange = "msvisibilitychange";
            state = "msVisibilityState";
        } else if (typeof document.webkitHidden !== "undefined") {
            hidden = "webkitHidden";
            visibilityChange = "webkitvisibilitychange";
            state = "webkitVisibilityState";
        }

        if (document[state] != undefined) {
            self._visible = document[state] == 'visible';
        }

        // 添加监听器，在title里显示状态变化
        if (document.addEventListener) {
            document.addEventListener(visibilityChange, function () {
                // console.log(document[state]);
                if (document[state] != undefined) {
                    self._visible = document[state] == 'visible';
                    onchange && onchange(self._visible);
                }
            }, false);
        }
    })(this);
};
PageVisible.prototype.visible = function () {
    return this._visible;
};

module.exports = PageVisible;
